
import React from "react";
import { Sidebar } from "./Sidebar";
import { ToastContainer } from "@/components/ui/toast/ToastContainer";

interface DashboardLayoutProps {
  children: React.ReactNode;
  userTier?: 1 | 2 | 3;
}

export function DashboardLayout({ children, userTier = 1 }: DashboardLayoutProps) {
  const handleLogout = () => {
    console.log("Logging out");
    // Actual logout logic would be implemented by the container
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Sidebar userTier={userTier} onLogout={handleLogout} />
      <div className="lg:pl-64 transition-all duration-300 min-h-screen">
        <main className="px-4 sm:px-6 py-8">{children}</main>
      </div>
      <ToastContainer />
    </div>
  );
}
